/*
 * Recommended VS Code Extension – "Comment Anchors" exodiusstudios.comment-anchors */
import GlobalFallbackSkeleton from 'packages/lib/common-ui/app-shell/app-layout';
import AnnotationToolSkeleton from 'packages/at-shell/components/app-shell/app-layout';
import { Suspense, lazy } from 'react';
import { Switch, useRouteMatch, Redirect } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import { customDefaultTheme } from 'packages/lib/common-ui/theme';
import { AnnotationToolRoute } from 'packages/main/routes/components/annotation-tool-route';
import AppPageSkeleton from 'packages/at-shell/components/app-shell/app-layout';

/**
 * ANCHOR - Tools & Views
 */
const PolarisTools = lazy(() => import('packages/main/pages/polaris/tools'));
const PolarisTool = lazy(() => import('packages/main/pages/polaris/search'));
const PolarisDataRequests = lazy(
  () => import('packages/main/pages/polaris/data-requests')
);
const UnderConstructionPage = lazy(
  () => import('packages/main/pages/under-construction')
);

/**
 * ANCHOR - Error Pages
 */
const ErrorPage404 = lazy(
  () => import('packages/lib/common-ui/error-pages/error-page-404')
);

const ErrorPage403 = lazy(
  () => import('packages/lib/common-ui/error-pages/error-page-403')
);

const MOBIS_UNDER_CONSTRUCTION = true;

export function Contractor(): JSX.Element {
  const match = useRouteMatch();
  return (
    <ConfigProvider
      theme={{
        ...customDefaultTheme,
        token: {
          borderRadius: 6,
        },
      }}
    >
      <Suspense fallback={<GlobalFallbackSkeleton />}>
        {MOBIS_UNDER_CONSTRUCTION ? (
          <AnnotationToolRoute>
            <UnderConstructionPage />
          </AnnotationToolRoute>
        ) : (
          <Switch>
            {/**
             * ANCHOR - Polaris Portal Routes
             */}
            <AnnotationToolRoute path={`${match.url}/polaris/tools`} exact>
              <Suspense
                fallback={<AppPageSkeleton skeletonMode theme="dark" />}
              >
                <PolarisTools />
              </Suspense>
            </AnnotationToolRoute>
            <AnnotationToolRoute exact path={`${match.url}`}>
              <Redirect to={`${match.url}/polaris/tools`} />
            </AnnotationToolRoute>

            <AnnotationToolRoute
              path={`${match.url}/polaris/data-requests`}
              exact
            >
              <Suspense
                fallback={<AppPageSkeleton skeletonMode theme="dark" />}
              >
                <PolarisDataRequests />
              </Suspense>
            </AnnotationToolRoute>

            <AnnotationToolRoute path={`${match.url}/polaris/:query?`} exact>
              <Suspense
                fallback={<AnnotationToolSkeleton skeletonMode theme="dark" />}
              >
                <PolarisTool />
              </Suspense>
            </AnnotationToolRoute>

            {/**
             * ANCHOR - Handle awkwardly non-existent paths
             */}
            <AnnotationToolRoute path={`${match.url}/tasks`} exact>
              <Redirect to={`${match.url}/tools`} />
            </AnnotationToolRoute>
            <AnnotationToolRoute path={`${match.url}/403`} exact>
              <ErrorPage403 />
            </AnnotationToolRoute>
            <AnnotationToolRoute path={`${match.url}/:no_path`} exact>
              <ErrorPage404 />
            </AnnotationToolRoute>
            <AnnotationToolRoute path={`${match.url}/:no_path/*`} exact>
              <ErrorPage404 />
            </AnnotationToolRoute>
          </Switch>
        )}
      </Suspense>
    </ConfigProvider>
  );
}

export default Contractor;
